import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { AuthService } from "src/app/auth/services/auth.service";
import { ConfigService } from "src/app/configurations/services/config.service";
import { MyTasksService } from "src/app/my-task/services/my-tasks.service";
import { environment } from "src/environments/environment";
import { PatientsService } from "../../patients/services/patients.service";
declare var $: any;

@Component({
  selector: "app-patient-details",
  templateUrl: "./patient-details.component.html",
  styleUrls: ["./patient-details.component.css"],
  providers: [MessageService],
})
export class PatientDetailsComponent implements OnInit {
  isInvalidPatientCode: boolean;
  isInvalidPatientEmail: boolean;
  isInvalidPatientPhone: boolean;
  isInvalidPatientLandline: boolean;
  editPatientEmail: boolean;
  loader: boolean;
  editPatientPhoneNumber: boolean;
  editPatientLandLineNumber: boolean;
  editAssignedDentist: boolean;
  editPatientNumber: boolean;
  editPatientDOB: boolean;
  editPatientsAddress: boolean;
  addressFormSubmitted: boolean;
  addressForm: any;
  patientDetails;
  DentistList;
  PatientID: any;
  isDuplicatePatientCode=false;
 
  editPatientTitle: boolean;
  patientEmail;
  patientPhoneNumber;
  patientLandLineNumber;
  AssignedDentist;
  patientRefNumber;
  patientDOB;
  patientTitle;
  AllEditAddress;
  ArchieveFlagValue: any = 0;
  @Input() isDataUpdate;
  LogData: any = [];
  submitted: boolean = false;
  isReferral = false;

  constructor(
    private patientService: PatientsService,
    private messageService: MessageService,
    private myTaskService: MyTasksService,
    private fb: FormBuilder,
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.PatientID = this.configService.dec(params["PatientID"]);
      this.ArchieveFlagValue = params["ArchiveFlag"];
      this.isReferral = params["ReferralID"] ? true : false;
      this.GetDentistList();
      this.GetPatientDetails();
    });
  }

  ngOnChanges() {
    if (this.isDataUpdate === 1) {
      this.GetPatientDetails();
    }
  }

  GetPatientDetails() {
    this.loader = true;
    this.patientService
      .getPatientDetails(
        this.PatientID,
        this.ArchieveFlagValue ? this.ArchieveFlagValue : 0
      )
      .subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            res["data"] = JSON.parse(this.configService.dec(res["data"]));
            if (res["data"] && res["data"].length > 0) {
              this.patientDetails = res["data"][0];
                                        
            } else {
              this.patientDetails = [];
            }
          } else {
            this.loader = false;
            this.patientDetails = [];
          }
        },
        (err) => {
          this.loader = false;
          this.patientDetails = [];
        }
      );
  }

  GetDentistList() {
    this.loader = true;
    this.patientService
      .getDentistList()
      .subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            res["data"] = JSON.parse(this.configService.dec(res["data"]));
            if (res["data"] && res["data"].length > 0) {
              this.DentistList = res["data"];
            } else {
              this.DentistList = [];
            }
          } else {
            this.loader = false;
            this.DentistList = [];
          }
        },
        (err) => {
          this.loader = false;
          this.DentistList = [];
        }
      );
  }

  AddressformInitialize() {
    this.addressForm = this.fb.group({
      PostCode: new FormControl("", Validators.required),
      AddressLine1: new FormControl("", Validators.required),
      AddressLine2: new FormControl(""),
      AddressLine3: new FormControl(""),
      Addresses: new FormControl(""),
      City: new FormControl(""),
      County: new FormControl(""),
    });
  }

  editPatientsEmail(PatientID) {
    this.InsertLog("Edit patient email");
    this.editPatientEmail = true;
    this.patientEmail=this.patientDetails.Email
  }

  sendPatientEmail(PatientID) {
    this.InsertLog("save patient email as " + this.patientEmail);
    this.loader = true;
    if(this.patientEmail && !this.isInvalidPatientEmail){
    this.patientService
      .UpdatePatientEmail(PatientID, this.patientEmail ? this.patientEmail : "")
      .subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            this.ShowToast(
              "success",
              "Success!!",
              "Patient's Email has been updated successfully."
            );
            this.GetPatientDetails();
            this.cancelPatientEmail();
          } else {
            this.loader = false;
            this.ShowToast(
              "warn",
              "Warning",
              "Unable to update Patient's email. Please try again"
            );
          }
        },
        (err) => {
          this.loader = false;
          this.ShowToast(
            "error",
            "Error!!",
            "Unable to update Patient's email. Please try again"
          );
        }
      );
    }else{
      this.loader=false
      return true
    }
  }

  cancelPatientEmail() {
    this.InsertLog("cancel edit patient email");
    this.patientEmail = "";
    this.editPatientEmail = false;
  }

  editPatientsPhoneNumber() {
    this.InsertLog("Edit patient phonenumber");
    this.editPatientPhoneNumber = true;
    this.patientPhoneNumber=this.patientDetails.PhoneNumber
  }

  sendPatientPhoneNumber(PatientID) {
    this.InsertLog("save patient phone number as " + this.patientPhoneNumber);
    this.loader = true;
    if (this.patientPhoneNumber && !this.isInvalidPatientPhone) {
      this.patientService
        .UpdatePatientPhoneNumber(
          PatientID,
          this.patientPhoneNumber ? this.patientPhoneNumber : ""
        )
        .subscribe(
          (res) => {
            if (res["success"]) {
              this.loader = false;
              this.ShowToast(
                "success",
                "Success!!",
                "Patient's Phone number has been updated successfully"
              );
              this.GetPatientDetails();
              this.cancelPatientPhoneNumber();
            } else {
              this.loader = false;
              this.ShowToast(
                "warn",
                "Warning",
                "Unable to update Patient's Phone number. Please try again"
              );
            }
          },
          (err) => {
            this.loader = false;
            this.ShowToast(
              "error",
              "Error!!",
              "Unable to update Patient's Phone number. Please try again"
            );
          }
        );
    } else {
      this.loader = false;
      return false;
    }
  }

  cancelPatientPhoneNumber() {
    this.InsertLog("cancel patient number");
    this.patientPhoneNumber = "";
    this.editPatientPhoneNumber = false;
  }

  editPatientsLandLineNumber() {
    this.InsertLog("Edit patient landline number");
    this.editPatientLandLineNumber = true;
    this.patientLandLineNumber=this.patientDetails.LandLineNumber
  }

  editPatientAssignedDentist() {
    this.InsertLog("Edit Assigned Dentist");
    this.editAssignedDentist = true;
    if(this.patientDetails.AssignedDentist)
    this.AssignedDentist=this.patientDetails.AssignedDentist;
    else
    this.AssignedDentist="";
  }

  cancelAssignedDentist() {
    this.InsertLog("cancel Assigned Dentist");
    this.AssignedDentist = "";
    this.editAssignedDentist = false;
  }

  sendAssignedDentist(PatientID) {
    this.InsertLog("save patient Assigned Dentist " + this.editAssignedDentist);
    this.loader = true;
    if (this.AssignedDentist) {
      this.patientService
        .UpdateAssignedDentist(PatientID, this.AssignedDentist)
        .subscribe(
          (res) => {
            if (res["success"]) {
              this.loader = false;
              this.ShowToast(
                "success",
                "Success!!",
                "Assigned Dentist updated successfully"
              );
              this.GetPatientDetails();
              this.cancelAssignedDentist();              

            } else {
              this.loader = false;
              this.ShowToast(
                "warn",
                "Warning",
                "Unable to update Assigned Dentist. Please try again"
              );
            }
          },
          (err) => {
            this.loader = false;
            this.ShowToast(
              "error",
              "Error!!",
              "Unable to update Assigned Dentist. Please try again"
            );
          }
        );
    } else {
      this.loader = false;
      return true;
    }
  }

  sendLandLineNumber(PatientID) {
    this.InsertLog(
      "save patient landline number as " + this.patientLandLineNumber
    );
    this.loader = true;
    if (this.patientLandLineNumber && !this.isInvalidPatientLandline) {
      this.patientService
        .UpdatePatientLandLineNumber(
          PatientID,
          this.patientLandLineNumber ? this.patientLandLineNumber : ""
        )
        .subscribe(
          (res) => {
            if (res["success"]) {
              this.loader = false;
              this.ShowToast(
                "success",
                "Success!!",
                "Patient's Landline Number has been updated successfully"
              );
              this.cancelPatientLandLineNumber();
              this.GetPatientDetails();
            } else {
              this.loader = false;
              this.ShowToast(
                "warn",
                "Warning",
                "Unable to update Patient's Landline Number. Please try again"
              );
            }
          },
          (err) => {
            this.loader = false;
            this.ShowToast(
              "error",
              "Error!!",
              "Unable to update Patient's Landline Number. Please try again"
            );
          }
        );
    } else {
      this.loader = false;
      return true;
    }
  }

  cancelPatientLandLineNumber() {
    this.InsertLog("cancel patient landline number");
    this.patientLandLineNumber = "";
    this.editPatientLandLineNumber = false;
  }

  editPatientReferenceNumber(patientID) {
    this.InsertLog("Edit patient reference number");
    document.getElementById("ddPatientCode").className  = "col-sm-7";
    this.editPatientNumber = true;
    this.patientRefNumber = this.patientDetails.PatientCode;
  }

  sendPatientReferenceNumber(PatientID) {
    this.submitted = true;
    this.InsertLog("save patient reference number as " + this.patientRefNumber);
    this.loader = true;
    if (this.patientRefNumber && !this.isInvalidPatientCode) {
      this.patientService
        .UpdatePatientRegNumberByPatientID(
          PatientID,
          this.patientRefNumber ? this.patientRefNumber : 0
        )
        .subscribe(
          (res) => {
            if (res["success"]) {            
              if(res["data"] && res["data"][0].error &&   res["data"][0].error==="Patient Code already exist")
              {
                this.isDuplicatePatientCode=true;
                // this.ShowToast(
                //   "warn",
                //   "Warning",
                //   "Patient Code already exist. Please try with different value "
                // );
              }
              else
              {
                this.loader = false;
                this.ShowToast(
                  "success",
                  "Success!!",
                  "Patient's Reference Number has been updated successfully"
                );
              
              this.GetPatientDetails();
              this.cancelPatientReferenceNumber();
              if (window.location.href.indexOf("membership") > -1) {
                window.location.reload();             
               } 
              } 
            } else {
              this.loader = false;
              this.ShowToast(
                "warn",
                "Warning",
                "Unable to updae Patient's Reference Number. Please try again"
              );
            }
          },
          (err) => {
            this.loader = false;
            this.ShowToast(
              "error",
              "Error!!",
              "Unable to updae Patient's Reference Number. Please try again"
            );
          }
        );
    } else {
      this.loader = false;
      return true;
    }
  }

  cancelPatientReferenceNumber() {
    this.InsertLog("cancel patient reference number");
    this.patientRefNumber = "";
    this.editPatientNumber = false;
  }

  editPatientsDOB(patientID) {
    this.InsertLog("Edit patient DOB");
    this.editPatientDOB = true;
    this.patientDOB=this.patientDetails.DOB
  }

  sendPatientDOB(PatientID) {
    this.InsertLog("save patient DOB as " + this.patientDOB);
    this.loader = true;
    if (this.patientDOB) {
      this.patientService
        .UpdatePatientDOB(PatientID, this.patientDOB ? this.patientDOB : "")
        .subscribe(
          (res) => {
            if (res["success"]) {
              this.loader = false;
              this.ShowToast(
                "success",
                "Success!!",
                "Patient's Date of Birth has been updated successfully"
              );
              this.GetPatientDetails();
              this.editPatientDOB = false;
              this.cancelPatientDOB();
            } else {
              this.loader = false;
              this.ShowToast(
                "warn",
                "Warning",
                "Unable to update Patient's Date of Birth. Please try again"
              );
            }
          },
          (err) => {
            this.loader = false;
            this.ShowToast(
              "error",
              "Error!!",
              "Unable to update Patient's Date of Birth. Please try again"
            );
          }
        );
    } else {
      this.loader = false;
    }
  }

  cancelPatientDOB() {
    this.InsertLog("Cancel patient DOB");
    this.patientDOB = "";
    this.editPatientDOB = false;
  }

  editPatientAddress(PatientID) {
    this.InsertLog("Edit patient address");
    this.editPatientsAddress = true;
  }

  savePatientAddress() {
    this.InsertLog("save patient address");
    this.loader = true;
    this.addressFormSubmitted = true;
    if (!this.addressForm.valid) {
      this.loader = false;
      return true;
    } else {
      var PatientData = {
        AddressID: this.patientDetails.AddressID,
        AddressLine1: this.addressForm.value.AddressLine1,
        AddressLine2: this.addressForm.value.AddressLine2,
        AddressLine3: this.addressForm.value.AddressLine3,
        City: this.addressForm.value.City,
        County: this.addressForm.value.County,
        PostCode: this.addressForm.value.PostCode,
        PatientID: this.PatientID,
      };
      this.patientService.UpdatePatientAddress(PatientData).subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            this.ShowToast(
              "success",
              "success",
              "Patient's Address has been updated auccessfully"
            );
            this.GetPatientDetails();
            this.cancelPatientAddress();
          } else {
            this.loader = false;
            this.ShowToast(
              "warn",
              "Warning",
              "Unable to update Patient's address. Please try again"
            );
          }
        },
        (err) => {
          this.loader = false;
          this.ShowToast(
            "error",
            "Error",
            "Unable to update Patient's address. Please try again"
          );
        }
      );
    }
  }

  cancelPatientAddress() {
    this.InsertLog("cancel patient address");
    this.editPatientsAddress = false;
    this.addressForm.reset();
    this.addressFormSubmitted = false;
    this.AddressformInitialize();
  }

  editPatientsTitle(patientID) {
    this.InsertLog("Edit patient title");
    this.editPatientTitle = true;
    this.patientTitle=this.patientDetails.Title
  }

  sendPatientTitle(PatientID) {
    this.InsertLog("save patient title as " + this.patientTitle);
    this.loader = true;
    if (this.patientTitle) {
      this.patientService
        .UpdateTitleForPatient(PatientID, this.patientTitle)
        .subscribe(
          (res) => {
            if (res["success"]) {
              this.loader = false;
              this.ShowToast(
                "success",
                "Success!!",
                "Patient's Title updated successfully"
              );
              this.GetPatientDetails();
              this.cancelPatientTitle();
            } else {
              this.loader = false;
              this.ShowToast(
                "warn",
                "Warning",
                "Unable to update Patient's title. Please try again"
              );
            }
          },
          (err) => {
            this.loader = false;
            this.ShowToast(
              "error",
              "Error!!",
              "Unable to update Patient's title. Please try again"
            );
          }
        );
    } else {
      this.loader = false;
      return true;
    }
  }

  cancelPatientTitle() {
    this.InsertLog("cancel patient title");
    this.patientTitle = "";
    this.editPatientTitle = false;
  }

  isValidPatientRefNUmber(event) {
    this.isDuplicatePatientCode = false;
    var pattern = new RegExp(environment.inputTypeTextNumberPattern);
    var result = pattern.test(event.target.value);
    if (!result) {
      this.isInvalidPatientCode = true;
    } else {
      this.isInvalidPatientCode = false;
    }
  }

  isValidPatientEmail(event) {
    var pattern = new RegExp(environment.emailPattern);
    var result = pattern.test(event.target.value);
    if (!result) {
      this.isInvalidPatientEmail = true;
    } else {
      this.isInvalidPatientEmail = false;
    }
  }

  isValidPatientPhone(event) {
    var pattern = new RegExp(environment.phonePattern);
    var result = pattern.test(event.target.value);
    if (!result) {
      this.isInvalidPatientPhone = true;
    } else {
      this.isInvalidPatientPhone = false;
    }
  }

  isValidPatientLandLine(event) {
    var pattern = new RegExp(environment.phonePattern);
    var result = pattern.test(event.target.value);
    if (!result) {
      this.isInvalidPatientLandline = true;
    } else {
      this.isInvalidPatientLandline = false;
    }
  }

  FindEditAddress() {
    var postcode = this.addressForm.controls["PostCode"].value;
    if (postcode) {
      this.myTaskService.GetAddresses(postcode).subscribe((res) => {
        this.AllEditAddress = res["addresses"];
      });
    } else {
    }
  }

  getEditAddress(e) {
    var result = e.target.value.split(", ");
    this.addressForm.patchValue({
      AddressLine1: result[0],
      AddressLine2: result[1],
      AddressLine3: result[2],
      City: result[result.length - 2] + " " + result[result.length - 3],
      County: result[result.length - 1],
    });
  }

  ShowToast(type, title, desc) {
    this.messageService.add({
      severity: type,
      summary: title,
      detail: desc,
    });
  }

  showPatientDetails() {
    this.router.navigate([
      "/patients/patient-view",
      {
        PatientID: this.configService.enc(this.patientDetails.PatientID.toString()),
        ArchiveFlag: 0,
        page: "Membership",
      },
    ]);
  }

  InsertLog(ButtonName) {
    if (this.router.url.startsWith("/membership")) {
      this.LogData.push({
        Notes: ButtonName,
        DateTime: new Date(),
        StaffName: this.auth.staffName,
      });
      localStorage.setItem("LogData", JSON.stringify(this.LogData));
    }
  }

  viewPatient() {
    this.router.navigate([
      "patients",
      "patient-view",
      {
        PatientID: this.configService.enc(
          this.patientDetails.PatientID.toString()
        ),
        ArchiveFlag: 0,
      },
    ]);
  }
  // [routerLink]="['/patients/patient-view',{'PatientID':patientDetails.PatientID,'ArchiveFlag':0,'page':'Membership'}]"
}
